export const authClientId = '1_18c13sz6jftw4s448kwcko0csk8ow00k840kg0ccso88okckgk';
export const authClientSecret = '4ldbi7mw5reo4k4k0owsk08cgckg0o0k4888840c4kcggo80kw';

// @ts-ignore
export const baseUrlApi = window.mygps.baseUrlApi;

export const titlePrefix = 'WAYFAYER';
export const titleDefult = '';

export const languages = [
    {
        name: 'PL',
        i18n: 'pl'
    },
    {
        name: 'EN',
        i18n: 'en'
    }
];